import { IconRefresh } from "@/assets/icons/geist/IconRefresh";
import { Nudge } from "@/components/nudges/Nudge";
import { NudgeKeys, useNudges } from "@/hooks/use-nudges";
import { TrackLocations } from "@/hooks/use-segment";
import { markNudgeShown } from "@/version-tracker";
import { useCallback, useEffect, useState, type FC } from "react";

export const VersionUpdateNudge: FC = () => {
    const { active: nudge, error, isPending } = useNudges();
    const [open, setOpen] = useState(false);

    useEffect(() => {
        if (isPending || error) {
            return;
        }

        if (nudge?.key === NudgeKeys.VERSION_UPDATE) {
            setOpen(true);
            return;
        }
        setOpen(false);
    }, [isPending, error, nudge?.key]);

    const handleRefresh = useCallback(() => {
        window.location.reload();
    }, []);

    const handleDismiss = useCallback(() => {
        setOpen(false);
        markNudgeShown();
    }, []);

    const ariaLabelPrefix = "Announcement - Version Update";
    return (
        <Nudge
            open={open}
            toggleOpen={handleDismiss}
            ariaLabelPrefix={ariaLabelPrefix}
            data-testid="nudge-version-update"
            data-track-location={TrackLocations.VersionUpdateNudge}
        >
            <Nudge.Content>
                <Nudge.Header>
                    <Nudge.Title>Update Available</Nudge.Title>
                    <Nudge.Description>
                        A new version of Ona is available. Refresh to get the latest features.
                    </Nudge.Description>
                </Nudge.Header>
                <Nudge.Action
                    size="sm"
                    variant="primary"
                    className="px-4"
                    aria-label={`${ariaLabelPrefix} - Refresh now`}
                    onClick={handleRefresh}
                    LeadingIcon={IconRefresh}
                    data-tracking-id="refresh-for-version-update"
                >
                    Refresh Now
                </Nudge.Action>
            </Nudge.Content>
        </Nudge>
    );
};
